<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qiYKXS/tc-custom/9781636240459.jpg?1726871296714" alt="This image is the cover for the book There Was a Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">There Was a Time
      </h1>
      <p class="bookDescription body article font2">
        <p>It is the summer of 1945, the last and very dangerous days of World War II. The Office of Strategic Services is in close, cooperative contact with Ho Chi Minh and the fighting cadre of the Viet Minh, working against the Japanese. In the closing months of the war, the OSS parachute a team of special operations soldiers into Tonkin, northern Viet Nam.  Led by Major John Guthrie and his second-in-command, Captain Edouard Parnell, both experienced officers from their earlier assignments in occupied France and Belgium, the team is tasked with working with Ho Chi Minh against the Japanese in the midst of various groups vying for control of Indochina. Guthrie and his team have to adapt to the entirely different context of Vietnamese politics in order to encourage communist operations against the Japanese. Guthrie in particular, struggles with both his personal and professional conflicts. The relationship that Guthrie and the rest of the OSS team develops with the Viet Minh leadership is of distinct annoyance to French ambitions to regain control of their colony, Indochina.  Based on the little-known true story of American and Viet Minh collaboration in 1945, this novel challenges the later-accepted dogma of both those supporting and those opposing the American role in the Viet Nam conflict. This novel notes how what is seen at a later time is often inadequate to understand what actually went on. Its contemporary relevance is simply a mirror of what is always the case in international affairs: today’s enemies can and may be tomorrow’s friends – and most importantly, the reverse is true also.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George H. Wittman
      </h2>
      
      <p class="authorDescription body article">George H. Wittman served in the US Army during and after the Korean War and, in the following decades, became intimately involved in national security, global intelligence matters and international business. A veteran of forty-five years of international security operations and analysis, he undertook extensive sensitive assignments across the globe. He served as founding chairman of the National Institute for Public Policy, lectured periodically at the FBI Academy in Quantico, VA, and had a consulting relationship with the FBI's New York field office. Above all, he viewed and presented himself as an American patriot, resisting political affiliation and committed to what he believed was in the best interest of the nation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3ade8519